import {
  classes as categoriesBreadcrumbsStylable,
  st as categoriesBreadcrumbsStyles,
} from './CategoriesBreadcrumbs.st.css';
import styles from './CategoriesBreadcrumbs.scss';
import React from 'react';
import {Breadcrumbs} from 'wix-ui-tpa/cssVars';
import {withGlobals} from '../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../../gallery/galleryGlobalStrategy';
import {DataHook} from '../../../common/ExtendedGridGallery/ExtendedGridGallery';
import classNames from 'classnames';

export const CategoriesBreadcrumbs: React.FunctionComponent<IGalleryGlobalProps> = withGlobals(
  (props: IGalleryGlobalProps) => {
    const {breadcrumbsHistory, shouldShowMobile, currentCategory, handleCategoryBreadcrumbsClick} = props.globals;

    return (
      <div data-hook={DataHook.Breadcrumbs} className={styles.breadcrumbsWrapper}>
        <Breadcrumbs
          items={breadcrumbsHistory}
          onClick={(item) => handleCategoryBreadcrumbsClick({item, originCategoryId: currentCategory.id})}
          className={classNames(
            categoriesBreadcrumbsStyles(categoriesBreadcrumbsStylable.breadcrumbs, {
              mobile: shouldShowMobile,
            })
          )}
          data-hook={DataHook.BreadcrumbsComponent}
          showTrailOnMobileMode={true}
        />
      </div>
    );
  }
);
